'use client';

import type { Ref } from 'react';
import { Textfield } from '@pie/amber';
import { formatUsPhone } from '@/lib/phone/usPhone';

type Props = {
  ref?: Ref<HTMLInputElement>;
  value: string;
  error: string | null;
  onChange: (value: string) => void;
};

export const MobileNumberField = ({ ref, value, error, onChange }: Props) => {
  const onPhoneChange = (value: string | number | readonly string[] | undefined) => {
    const formatted = formatUsPhone(String(value ?? ''));
    onChange(formatted);
  };
  return (
    <Textfield
      ref={ref}
      className="max-w-[18.75rem]"
      label="Mobile number"
      placeholder="XXX-XXX-XXXX"
      helpText={error ? undefined : 'Enter a mobile number for account alerts'}
      errorText={error ?? undefined}
      value={value}
      onValueChange={onPhoneChange}
    />
  );
};
